import axios, { CancelToken } from 'axios';
import { IRegrasFormValues } from '../../../../pages/ConfiguracoesReceitas/interface';
import { GATEWAY_API_URL } from "../../../request/urls";
import { getToken } from "../../../token";

class RegrasReceitasService {
    async getRegras(signal?: CancelToken) {
        const { data } = await axios.get(`${GATEWAY_API_URL}/receitas-ipm/regras`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async postRegras(values: IRegrasFormValues, signal?: CancelToken) {
        const { data } = await axios.post(`${GATEWAY_API_URL}/receitas-ipm/regras/${values.ano}`, values, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async putRegras(values: IRegrasFormValues, signal?: CancelToken) {
        const { data } = await axios.put(`${GATEWAY_API_URL}/receitas-ipm/regras/${values.ano}`, values, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async deleteRegras(ano: number, signal?: CancelToken) {
        const { data } = await axios.delete(`${GATEWAY_API_URL}/receitas-ipm/regras/${ano}`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async uploadFile(formData: FormData, ano: number, signal?: CancelToken) {
        const { data } = await axios.post(`${GATEWAY_API_URL}/receitas-ipm/regras/${ano}/importar-planilha`,
            formData,
            {
                headers: {
                    Authorization: 'Bearer ' + getToken(),
                    'Content-Type': 'multipart/form-data',
                },
                cancelToken: signal,
            }
        );

        return data;
    }
}

export default new RegrasReceitasService();
